module.exports = __webpack_public_path__ + "img/ClosePopup.909b323f.svg";